import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqData: FAQItem[] = [{
  question: '¿El curso de $297 viene con todos los bonos prometidos o hay un límite de tiempo?',
  answer: 'Sí, hay un límite de tiempo. Pero si estás en esta página ahora mismo, sigue adelante y completa tu orden y recibirás los bonos.'
}, {
  question: '¿Ofrecen planes de pago?',
  answer: 'Sí, ofrecemos planes de pago a través de Zip. Normalmente, si estás en Estados Unidos y tienes un puntaje de crédito de más de 580, puedes ser aprobado para hasta 4 pagos. Si no estás en Estados Unidos, puedo aprobarte internamente para 2 pagos de $175 cada 30 días.'
}, {
  question: 'Estoy en Estados Unidos y no me aprobaron el financiamiento. ¿Qué hago?',
  answer: 'Si no te aprobaron a través del financiamiento, hay un chat de WhatsApp aquí en esta página. Contáctame directamente para ver qué otras opciones de financiamiento están disponibles para ti.'
}, {
  question: 'Compré y no recibí acceso. ¿Qué debo hacer?',
  answer: 'Si compraste algo relacionado con TrueMarketer o 48 Hrs AI Cash Machine, envía un correo a mi equipo de soporte con tu recibo a support@truemarketer.com.'
}, {
  question: '¿Este curso incluye coaching contigo? ¿Qué más incluye?',
  answer: 'Todo lo que ves en esta página está incluido. Sí, ofrezco una llamada al mes con todos los estudiantes dentro de este programa, y también acceso a un grupo privado de Facebook solo para miembros.'
}, {
  question: 'Vi un programa de seis meses. ¿Es diferente a este?',
  answer: 'Sí. Mi programa de implementación de seis meses incluye todo lo de este programa, más una llamada semanal conmigo para responder tus preguntas y guiarte en la transformación que estás buscando durante los próximos seis meses. Si quieres más información sobre el programa privado de implementación por seis meses, hay un ícono de WhatsApp en esta página—envíame un mensaje preguntando cómo obtener más información sobre el programa de implementación por seis meses.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="max-w-4xl mx-auto my-16 px-4" data-id="element-177">
      <div className="text-center mb-12" data-id="element-178">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-179">
          Preguntas Frecuentes
        </h2>
        <p className="text-lg text-gray-600" data-id="element-180">
          Encuentra respuestas a las preguntas más comunes
        </p>
      </div>
      <div className="space-y-4" data-id="element-181">
        {faqData.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-lg" data-id="element-182">
            <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 transition-colors duration-200 hover:bg-gray-50" data-id="element-183">
              <span className="text-lg font-semibold text-gray-900 pr-4" data-id="element-184">
                {faq.question}
              </span>
              <ChevronDown className={`w-6 h-6 text-green-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-185" />
            </button>
            <div className={`transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`} data-id="element-186">
              <div className="px-6 pb-5 pt-2" data-id="element-187">
                <p className="text-gray-700 leading-relaxed" data-id="element-188">{faq.answer}</p>
                {index === 0 && <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-green-600 to-green-800 hover:from-green-700 hover:to-green-900 text-white font-bold py-3 px-6 rounded-lg text-base transition-all transform hover:scale-105 shadow-lg hover:shadow-xl mt-4" data-id="element-189">
                    ¡Obtén Acceso Ahora!
                  </a>}
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}